import { VisuallyHidden } from './VisuallyHidden';

// TODO: in v9, move styled() from VisuallyHidden.jsx to here
export var StyledVisuallyHidden = VisuallyHidden;